<div class="city-postal-code">
    <div>
        <up-autocomplete class="increase-width" [fieldLabel]="placeHolder" [fieldMessage]="locationAutoCompleteMessage"
            [formatInput]="formatter" [items]="results" [template]="listTemplate"
            (autocompleteItemSelected)="onLocationSelect($event)" [errorState]="locationAutoCompleteState">
            <input type="text" #findLocationInput (input)="triggerRestSearch(findLocationInput.value)"
                [formControl]="locationControl" (blur)="onBlur(findLocationInput.value)" required />
                @if(!inputStringValue && locationAutoCompleteState !== 'error'){
                    <up-icon name="search"></up-icon>
                }
                @if(!inputStringValue && locationAutoCompleteState === 'error'){
                    <up-icon name="error"></up-icon>
                }
        </up-autocomplete>
        <up-progress-indicator progress-style="linear" [active]="isActive"></up-progress-indicator>
    </div>
</div>
